<div class="basic-btn-with-icon btn-with-theme" [ngClass]="theme">
    <button class="btn" mat-button
    [type]="type"
    [color]="color"
    [disabled]="disabled"
    [ngClass]="{'uc': uppercase}"
    [ngStyle]="{'fontWeight': fontWeight}"
    >
        <div class="btn-icon-text-wrapper">
            {{iconPosition == 'right' ? text : ''}}
            <div class="btn-icon-wrapper">
                <ng-container *ngIf="!iconSrc">
                  <mat-icon class="material-icons-outlined btn-icon" [color]="iconColor">{{icon}}</mat-icon>
                </ng-container>

                <ng-container *ngIf="iconSrc">
                  <app-svg-icon src="{{iconSrc}}" width="20px" height="20px"></app-svg-icon>
                </ng-container>
            </div>
            {{iconPosition == 'left' ? text : ''}}
        </div>
    </button>
</div>
